import { groupByMonthYear } from './groupByMonthYear';
import { formatDateToLima } from './dateUtils';

const DAY_NAMES = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

/**
 * Agrupa ítems por mes/año y, dentro de cada mes, por día.
 * @returns {{ key, label, year, month, items, dayGroups: { key, label, date, items }[] }[]}
 */
export function groupByMonthYearDay(items, getDate) {
  const monthGroups = groupByMonthYear(items, getDate);

  return monthGroups.map((monthGroup) => {
    const dayMap = new Map();

    for (const item of monthGroup.items) {
      const dayKey = formatDateToLima(getDate(item)) || '__sin_fecha__';

      if (!dayMap.has(dayKey)) {
        if (dayKey === '__sin_fecha__') {
          dayMap.set(dayKey, {
            key: dayKey,
            label: 'Sin fecha',
            date: null,
            items: [],
          });
        } else {
          const [year, month, day] = dayKey.split('-').map(Number);
          const dateObj = new Date(year, month - 1, day, 12, 0, 0, 0);
          const dayName = DAY_NAMES[dateObj.getDay()];
          dayMap.set(dayKey, {
            key: dayKey,
            label: `${dayName} ${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`,
            date: dayKey,
            items: [],
          });
        }
      }

      dayMap.get(dayKey).items.push(item);
    }

    const dayGroups = Array.from(dayMap.values()).sort((a, b) => {
      if (a.key === '__sin_fecha__') return 1;
      if (b.key === '__sin_fecha__') return -1;
      return b.key.localeCompare(a.key);
    });

    return {
      ...monthGroup,
      dayGroups,
    };
  });
}

export default groupByMonthYearDay;
